/**
 * 
 * key
 * 
 */


const key = 'cXVlc3Rpb25fbGlzdA=='

export default key 